import dayjs from "dayjs";
import { Inspection, InspectionElement, InspectionStatus } from "../types/inspection";

const CONFIG_STATUS_MAP: Record<string, InspectionStatus> = {
    not_started: InspectionStatus.UPCOMING,
    pending: InspectionStatus.UPCOMING,
    in_progress: InspectionStatus.COMMENCED,
    submitted: InspectionStatus.INSPECTION_COMPLETED,
    completed: InspectionStatus.INSPECTION_COMPLETED,
    full_report: InspectionStatus.FULL_REPORT,
    cancelled: InspectionStatus.CANCELLED,
    deleted: InspectionStatus.CANCELLED
};

export const formatInspectionDate = (inspection: Inspection) => {
    const { inspectionDateFrom: DateTimeFrom, inspectionDateTo: DateToFrom } = inspection;
    let date = "";

    if (DateTimeFrom) {
        date += dayjs(DateTimeFrom).format("DD/MM/YYYY");
    }

    if (DateTimeFrom && DateToFrom) {
        date += " - ";
    }

    if (DateToFrom) {
        date += dayjs(DateToFrom).format("DD/MM/YYYY");
    }

    return date;
}

export const getInspectionPhotoFolders = (inspection: Inspection) => {
    const photoFolders: InspectionElement[] = [];

    if (inspection.inspectionReport) {
        inspection.inspectionReport.forEach((inspectionElement) => {
            if (inspectionElement.ElementType === 2 && inspectionElement.AvailableForCustomer) {
                photoFolders.push(inspectionElement);
            }
        })
    }

    return photoFolders.sort((a, b) => a.SortOrder - b.SortOrder);
}

const asString = (value: unknown) => (typeof value === "string" && value !== "" ? value : null);

/**
 * Shapes an inspect-backend record into the Inspection the editor expects.
 * Config-driven inspections have no ASIMS row, so the ASIMS-only fields
 * (report tree, grades, pricing) are absent rather than empty.
 */
export const mapConfigInspection = (record: Record<string, unknown>): Inspection => ({
    id: (record.id as string) ?? (record.inspectionId as string),
    vesselName: asString(record.vesselName),
    vesselImo: asString(record.vesselImo) ?? asString(record.vesselId),
    inspectionTypeId: null,
    inspectionType: asString(record.inspectionType) ?? asString(record.checklistType),
    inspectionNumber: asString(record.inspectionNumber),
    inspectionDateFrom: asString(record.inspectionDate),
    inspectionDateTo: asString(record.inspectionDateTo),
    inspectionReport: null,
    orderedDate: null,
    issuedAt: null,
    reportDate: null,
    status: CONFIG_STATUS_MAP[record.status as string] ?? null,
    port: asString(record.location),
    country: null,
    recommendedPrice: null,
    quoteLink: null,
    earlyRelease: null,
    vesselType: asString(record.shipType),
    overallScore: null,
    managementScore: null,
    conditionScore: null,
    totalPrice: null,
    enableLowPriorityDefects: false,
    grades: null,
    images: (record.images as Inspection["images"]) ?? null,
    pipeline: asString(record.pipeline),
    checklistType: asString(record.checklistType),
    checklistVersion: asString(record.checklistVersion)
});
